import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { AlertTriangle, ArrowLeft, Home } from "lucide-react";
import Button from "@/components/Buttons/Button";

const NotFoundPage = () => {
  const navigate = useNavigate();
  const [isLoaded, setIsLoaded] = useState(false);

  // Set loaded state after component mounts
  useEffect(() => {
    setIsLoaded(true);
  }, []);

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.5,
        when: "beforeChildren",
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { duration: 0.5 } },
  };

  return (
    <motion.div
      className="flex w-full min-h-screen flex-col items-center justify-center text-white bg-gradient-to-b from-gray-900 via-gray-900 to-black p-4"
      variants={containerVariants}
      initial="hidden"
      animate={isLoaded ? "visible" : "hidden"}
    >
      {/* Background decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-primary-900/20 via-transparent to-transparent"></div>
        <div className="absolute bottom-0 right-0 w-full h-full bg-[radial-gradient(ellipse_at_bottom_left,_var(--tw-gradient-stops))] from-primary-900/10 via-transparent to-transparent"></div>
      </div>

      <motion.div
        className="relative z-10 max-w-2xl w-full text-center"
        variants={itemVariants}
      >
        <div className="mb-8 flex justify-center">
          <div className="relative">
            <div className="absolute -inset-1 bg-gradient-to-r from-gaming-red to-gaming-accent rounded-full blur opacity-70"></div>
            <div className="relative p-4 bg-gaming-dark rounded-full">
              <AlertTriangle size={64} className="text-white" />
            </div>
          </div>
        </div>

        <h1 className="text-6xl font-bold mb-4">
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-gaming-red to-gaming-accent">
            404
          </span>
        </h1>

        <h2 className="text-3xl font-bold mb-4 text-white">
          Página não encontrada
        </h2>

        <p className="text-gray-300 mb-8 text-lg">
          Ops! Parece que você se aventurou em território desconhecido. A página
          que você está procurando não existe ou foi movida.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <div className="relative group">
            <div className="absolute -inset-0.5 bg-gradient-to-r from-gaming-red to-gaming-accent rounded-lg blur opacity-75 group-hover:opacity-100 transition duration-1000 group-hover:duration-200 animate-tilt"></div>
            <Button
              label="Voltar para a página inicial"
              onClick={() => navigate("/")}
              className="relative bg-gaming-red hover:bg-gaming-red/90 text-white flex items-center gap-2"
              icon={<Home size={16} />}
            />
          </div>

          <Button
            outline
            label="Voltar"
            onClick={() => navigate(-1)}
            className="text-white hover:bg-gaming-red/20 flex items-center gap-2"
            iconPosition="left"
            icon={<ArrowLeft size={16} />}
          />
        </div>
      </motion.div>
    </motion.div>
  );
};

export default NotFoundPage;